import { type ReactNode, useEffect, useState } from 'react';

interface Props {
  children: ReactNode;
}

/**
 * Pattern taken from https://www.joshwcomeau.com/react/the-perils-of-rehydration
 */
export default ({ children }: Props) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return children;
};
